import moment from "moment";
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters("rateProducts", ["getCurrentScore"]),
        isLessThan3Days() {
            const currentTime = new Date(this.order.current_time);
            const statusDate = new Date(this.order.status.status_date);

            const diffMs = currentTime - statusDate;
            const diffDays = diffMs / (1000 * 60 * 60 * 24);

            return diffDays < 3;
        },
        deliveryDateFormatted() {
            const months = [
                "Января",
                "Февраля",
                "Марта",
                "Апреля",
                "Мая",
                "Июня",
                "Июля",
                "Августа",
                "Сентября",
                "Октября",
                "Ноября",
                "Декабря",
            ];

            const deliveryMoment = moment(this.order.delivery_time);
            const day = deliveryMoment.format("D");
            const monthIndex = parseInt(deliveryMoment.format("MM")) - 1;
            const year = deliveryMoment.format("YYYY");

            return `${day} ${months[monthIndex]} ${year}`;
        },
        deliveryDateWithType() {
            const date = this.deliveryDateFormatted;

            let delType;
            switch (this.order.delivery_type) {
                case "delivery":
                    delType = "Доставка";
                    break;
                case "hall":
                    delType = "Зал";
                    break;
                case "gift_certificate":
                    delType = "Подарочной сертификат";
                    break;
                default:
                    delType = "Самовывоз";
                    break;
            }

            return `${delType} - ${date}`;
        },
        notCanSend() {
            return (
                this.order.can_score &&
                this.isLessThan3Days &&
                (!this.getCurrentScore(this.order.id) || !this.getCurrentScore(this.order.id)?.order_scores?.score > 0)
            );
        },
    },
    methods: {},

    data() {
        return {
            rateError: false,
        };
    },
};
